import { Button } from "@/components";
import { useNewNavigate } from "@/shared/client";
import { useBookingCheckValue } from "@/shared/client/states/bookingCheck.state";
import { Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { BookingList } from "./bookingList";

export const BookingConfirm = () => {
    const bookingCheckValue = useBookingCheckValue();
    const { onNavigate } = useNewNavigate();

    useEffect(() => {
        onNavigate({ path: "/bookingConfirm", replace: true });
    }, []);

    return (
        <>
            <Helmet>
                <title>Marginmax | 예약조회 결과</title>
            </Helmet>
            <Flex w="100%" flexDir="column" gap="48px" alignItems="center">
                {bookingCheckValue ? (
                    <BookingList data={bookingCheckValue} />
                ) : (
                    <Text>oops!! 조회 신청하신 데이터가 없습니다.</Text>
                )}
                <CustomButton size="medium" onClick={() => onNavigate({ path: "/bookingCheck" })}>
                    조회 페이지로 가기
                </CustomButton>
            </Flex>
        </>
    );
};

const CustomButton = styled(Button)`
    border: 1px solid ${({ theme }) => theme.COLOR.gray[300]} !important;
`;
